import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { stockTanksData } from "./tankkd.jsx";
import HeaderBis from "../components/layout/headerbis";
import backgroundImage from "./../assets/img/header1.webp";

export default function ProductPage() {
  const { name } = useParams();
  const navigate = useNavigate();
  const product = stockTanksData.find(
    (p) => p.url === decodeURIComponent(name)
  );

  const hasVariants = !!product?.variants;
  const [selectedVariant, setSelectedVariant] = useState("rond");
  const [selectedSize, setSelectedSize] = useState(null);

  if (!product) {
    return <div className="pt-24 text-center text-gray-700">Produit introuvable.</div>;
  }

  const variantData = hasVariants ? product.variants[selectedVariant] : product;

  if (!selectedSize && variantData?.sizes?.length > 0) {
    setSelectedSize(variantData.sizes[0]);
  }

  const formattedDescription = (variantData?.description || product.description || "")
    .split("→")
    .filter(Boolean)
    .map((line, idx) => (
      <p key={idx} className="mb-2">
        → {line.trim()}
      </p>
    ));

  const handleDevis = () => {
    if (!selectedSize) return;

    const variantText = hasVariants ? ` (${selectedVariant})` : "";

    const commentaireAuto = `Je souhaite obtenir un devis pour : 
      ${product.name}${variantText}
      Taille : ${selectedSize.taille}
      Prix : ${selectedSize.prix}`;

    navigate(`/devis?commentaire=${encodeURIComponent(commentaireAuto)}`);
  };

  return (
    <div>
      <HeaderBis
        backgroundImage={backgroundImage}
        title={product.name}
        desc="Détails du Pack"
      />
      <div className="pt-16 px-4 md:px-16 lg:px-32 pb-16 bg-gray-50">
        <div className="flex flex-col md:flex-row gap-10">
          <div className="md:w-1/2">
            <img
              src={variantData?.image || product.image}
              alt={`${product.name}${selectedVariant ? " " + selectedVariant : ""}`}
              className="w-full h-auto object-cover rounded-xl"
            />
          </div>

          <div className="md:w-1/2 flex flex-col justify-between">
            <div className="mb-2">
              <h1 className="text-4xl font-bold mb-6">{product.name}</h1>
              <div className="text-gray-700 text-lg mb-6">{formattedDescription}</div>

              {hasVariants && (
                <div className="mb-2">
                  <h2 className="text-xl font-semibold mb-3">Choix :</h2>
                  <div className="flex gap-3">
                    {Object.keys(product.variants).map((variantKey) => (
                      <button
                        key={variantKey}
                        onClick={() => {
                          setSelectedVariant(variantKey);
                          setSelectedSize(product.variants[variantKey].sizes[0]);
                        }}
                        className={`border rounded-xl py-2 px-4 text-sm capitalize transition ${
                          selectedVariant === variantKey
                            ? "bg-[#005478] text-white border-[#005478]"
                            : "hover:bg-gray-200"
                        }`}
                      >
                        {variantKey}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {variantData?.sizes && (
                <div>
                  <div className="flex flex-wrap gap-3">
                    {variantData.sizes.map((size) => (
                      <button
                        key={size.taille}
                        onClick={() => setSelectedSize(size)}
                        className={`border rounded-xl py-2 px-2 text-sm transition ${
                          selectedSize?.taille === size.taille
                            ? "bg-[#005478] text-white border-[#005478]"
                            : "hover:bg-gray-200"
                        }`}
                      >
                        {size.taille} – {size.prix}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <button
              onClick={handleDevis}
              className="w-72 bg-[#db7d2b] text-white py-4 rounded-xl hover:bg-[#b9671c] text-lg font-semibold transition"
            >
              Demander un devis
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
